// btw-front/src/api/adminPartnerUsers.js
import { api } from "./client";

export async function list() {
  const res = await api.get("/admin/partner-users");
  return res.items || [];
}

// 계정 이메일(비밀번호 재설정 수신처) 변경 — 다른 계정과 같은 이메일도 허용(로그인 ID 만 유일)
export async function updateEmail(id, email) {
  return api.put(`/admin/partner-users/${encodeURIComponent(id)}/email`, { email });
}
